<template>
  <VisitorWrapper>
    <CContainer>
      <!-- GET SCHOOL SETTINGS ERROR -->
      <VisitorErrorHandler
        v-if="serverError != null"
        :error="serverError"
        @done="serverError = null"
      />
      <!-- GET SCHOOL SETTINGS ERROR -->

      <!-- Single loading state: screen readers need status + spinner (not decorative alone) -->
      <CRow
        v-if="isSchoolSettingsLoading"
        class="d-flex align-content-center justify-content-center mt-4 bg-white rounded-30 p-5 d-flex flex-column gap-2"
        aria-busy="true"
      >
        <div
          class="sr-only"
          role="status"
          aria-live="polite"
          aria-atomic="true"
        >
          Loading visitor list settings.
        </div>
        <CSpinner color="primary" aria-hidden="true" />
      </CRow>

      <template v-else>
        <!-- WATCHLIST -->
        <CRow
          class="justify-content-center mt-4 bg-white rounded-30 p-4 d-flex flex-column gap-2"
        >
          <VisitorWatchListTable />
        </CRow>

        <!-- SECURITY STAFF -->
        <CRow
          class="justify-content-center mt-6 bg-white rounded-30 p-4 d-flex flex-column gap-2"
        >
          <VisitorSecurityStaffTable />
        </CRow>

        <!-- EMERGENCY CONTACT -->
        <CRow
          class="justify-content-center mt-6 bg-white rounded-30 p-4 d-flex flex-column gap-2"
        >
          <VisitorEmergencyContactTable />
        </CRow>

        <!-- PRE-APPROVED LIST -->
        <CRow
          v-if="isPreApprovedSettingActive"
          class="justify-content-center mt-6 bg-white rounded-30 p-4 d-flex flex-column gap-2"
        >
          <VisitorPreApprovedListTable />
        </CRow>
      </template>
    </CContainer>
  </VisitorWrapper>
</template>
<script>
import VisitorWrapper from "@/v3components/VisitorWrapper.vue"
import VisitorWatchListTable from "@/v3components/Datatables/Visitor/ListSettings/VisitorWatchListTable.vue"
import VisitorSecurityStaffTable from "@/v3components/Datatables/Visitor/ListSettings/VisitorSecurityStaffTable.vue"
import VisitorEmergencyContactTable from "@/v3components/Datatables/Visitor/ListSettings/VisitorEmergencyContactTable.vue"
import VisitorPreApprovedListTable from "@/v3components/Datatables/Visitor/ListSettings/VisitorPreApprovedListTable.vue"
import VisitorErrorHandler from "@/v3components/VisitorErrorHandler.vue"
import visitorConstants from "@/constants/visitorConstants"
import { onMounted, ref, computed } from "vue"
import { useStore } from "vuex"
import { announce } from "@/composables/useLiveAnnouncer"

export default {
  name: "VisitorListSettings",
  components: {
    VisitorErrorHandler,
    VisitorWatchListTable,
    VisitorSecurityStaffTable,
    VisitorEmergencyContactTable,
    VisitorPreApprovedListTable,
    VisitorWrapper
  },
  setup() {
    const store = useStore()
    const isSchoolSettingsLoading = ref(true)
    const serverError = ref(null)

    const school = computed(() => store.getters["visitorSettings/school"])

    const visitorSchoolData = computed(() => {
      return school?.value?.data || null
    })

    const preApprovedSetting = computed(() => {
      return (
        visitorSchoolData.value?.building_settings?.find(
          (setting) =>
            setting?.settings_id ===
            visitorConstants.SETTINGS.PRE_APPROVED_VISITOR
        ) || null
      )
    })

    const isPreApprovedSettingActive = computed(() => {
      return preApprovedSetting.value?.value === "true"
    })

    onMounted(async () => {
      try {
        isSchoolSettingsLoading.value = true
        /* The in-place loading region mounts already-populated (v-if), so NVDA
           does not reliably re-read it. Push the status into the persistent
           global live region instead (axe: status-msg-not-auto-announced). */
        announce("Loading visitor list settings.")
        await store.dispatch("visitorSettings/getSchoolSettings")
      } catch (error) {
        serverError.value = error
      } finally {
        isSchoolSettingsLoading.value = false
      }
    })

    return {
      isSchoolSettingsLoading,
      isPreApprovedSettingActive,
      serverError
    }
  }
}
</script>

<style scoped></style>
